import React, { useState, useMemo } from 'react';
import { connect } from 'react-redux';
import {
  Box,
  Button,
  Grid,
  TextField
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { DataGrid } from '@material-ui/data-grid';

import MeasurementsModal from 'components/SalesOrders/MeasurementsModal';

import { setNewSOProducts } from 'redux/actions';

const CustomFooter = (props) => (
  <React.Fragment>
    { props.selectionModel.length === 1 ?
      <Grid container>
        <Grid item style={{padding: 8, display: 'flex'}}>
          <Button
            variant="contained"
            color="primary"
            onClick={props.setOpenMeasureModal.bind(this, true)}
          >
            Add Measurement
          </Button>
        </Grid>
        <Grid item style={{padding: 8, display: 'flex'}}>
          <Button
            variant="contained"
            color="secondary"
            onClick={props.deleteTableRows}
          >
            Delete Product(s)
          </Button>
        </Grid>
      </Grid>
    : null }
  </React.Fragment>
);

const AddProducts = ({soProducts, setNewSOProducts, ...props}) => {

  const [productInput, setProductInput] = useState({});
  const [quantity, setQuantity] = useState("");
  const [barcodeInput, setBarcodeInput] = useState("");

  const [openMeasureModal, setOpenMeasureModal] = useState(false);
  const [selectionModel, setSelectionModel] = useState([]);

  const elementsObj = useMemo(() => (
    props.elements
      .map(element => {
        const firstLetter = element.name[0].toUpperCase();
        return {
          firstLetter,
          productId: element.id,
          productDisplayId: element.displayId,
          name: element.name,
          category: element.category,
          company: element.company
        }
      })
      .filter(element => !soProducts.some(item => element.productId === item.productId))
      .sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))
  
  ), [props.elements, soProducts]);

  const columns = [
    { field: 'displayId', headerName: 'ID', flex: 1 },
    { field: 'name', headerName: 'Product Name', flex: 1 },
    { field: 'category', headerName: 'Category', flex: 1 },
    { field: 'company', headerName: 'Brand', flex: 1 },
    { field: 'sellPrice', headerName: 'Selling Price', type: 'number', flex: 1, editable: true }
  ];

  //only useful if Sales Order Editing is enabled.
  /*useEffect(() => {
    if(so_products.length > 0){
      setNewSOProducts(so_products.map( productObj => {
        const rowInfo = props.elements.find(element => element.id === productObj.product_id)
        return {
          ...productObj,
          category: rowInfo?.body.category
        }
      }))
    }
    // eslint-disable-next-line
  }, [props.elements, setNewSOProducts])*/

  const checkProductBarcode = (e) => {
    setBarcodeInput(e.target.value);

    if(e.target.value.length > 3) {
      const productInfo = props.elements.find(element => element.barcode === e.target.value);
      if(productInfo) {
        const isProductAdded = soProducts.some(soProduct => soProduct.productId === productInfo.id);
        if( !isProductAdded ) {
          const firstLetter = productInfo.name[0].toUpperCase();
          setProductInput({
            firstLetter,
            productId: productInfo.id,
            productDisplayId: productInfo.displayId,
            name: productInfo.name,
            category: productInfo.category,
            company: productInfo.company
          });
        }
        setBarcodeInput("");
      }
    }
  };

  const insertProducts = () => {
    let products = [];

    for ( let i = 1; i <= quantity; i++ ) {
      //'id' field is added only for the DataGrid object.
      products.push({
        id: `${props.soDisplayId}/${productInput.productDisplayId}/${i}`,
        displayId: `${props.soDisplayId}/${productInput.productDisplayId}/${i}`,
        productId: productInput.productId,
        productDisplayId: productInput.productDisplayId,
        name: productInput.name,
        category: productInput.category,
        company: productInput.company,
        sellPrice: 0,
        measurements: ""
      });
    }
    setNewSOProducts([...soProducts, ...products]);
    setProductInput({});
    setQuantity("");
  };

  const handleEditCellChangeCommitted = React.useCallback(
    ({ id, field, props }) => {
      const priceIndex = soProducts.findIndex(product => product.id === id);
      setNewSOProducts([
        ...soProducts.slice(0, priceIndex),
        {
          ...soProducts[priceIndex],
          sellPrice: parseFloat(props.value) || soProducts[priceIndex].sellPrice
        },
        ...soProducts.slice(priceIndex + 1)
      ]);
    }, [soProducts, setNewSOProducts]
  );

  const addProductMeasurements = (measurements) => {
    const measureIndex = soProducts.findIndex(product => product.id === selectionModel[0]);
    setNewSOProducts([
      ...soProducts.slice(0, measureIndex),
      {
        ...soProducts[measureIndex],
        measurements
      },
      ...soProducts.slice(measureIndex + 1)
    ]);
  };

  const deleteTableRows = () => {
    const deletedProduct = soProducts.find(product => product.id === selectionModel[0]);
    const updatedSOProducts = soProducts.filter(product => !selectionModel.includes(product.id));

    let productCount = 1;
    updatedSOProducts.forEach(product => {
      if(product.productId === deletedProduct.productId) {
        product.id = `${props.soDisplayId}/${deletedProduct.productDisplayId}/${productCount}`;
        product.displayId = `${props.soDisplayId}/${deletedProduct.productDisplayId}/${productCount}`;

        productCount++;
      }
    });
    
    setNewSOProducts(updatedSOProducts);
    setSelectionModel([]);
  };

  const handleMeasureModalClose = () => {
    setOpenMeasureModal(false);
    setSelectionModel([]);
  };

  return (
    <React.Fragment>
       <Box marginTop={3}>
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            md={4}
            xs={12}
          >
            <Autocomplete
              onChange={(event, newValue) => {
                if(newValue) setProductInput(newValue);
                else setProductInput({});
              }}
              id="free-solo-dialog-demo"
              fullWidth
              options={elementsObj}
              groupBy={(product) => product.firstLetter}
              getOptionSelected={(option, value) => option.productId === value.productId}
              getOptionLabel={(option) => option.name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Product.."
                  variant="outlined"
                />
              )}
              value={productInput ? ( productInput.productId ? productInput : null ) : null }
            />
          </Grid>
          <Grid
            item
            md={4}
            xs={12}
          >
            <TextField
              fullWidth
              label="Scan Barcode"
              name="barcode"
              onChange={(event) => checkProductBarcode(event)}
              value={barcodeInput}
              variant="outlined"
            />
          </Grid>
          <Grid
            item
            md={4}
            xs={12}
          >
            <Box
              display="flex"
              alignItems="center"
            >
              <TextField
                style={{ flexShrink: 1 }}
                fullWidth
                label="Quantity"
                onChange={(event) => setQuantity(parseFloat(event.target.value) || 0)}
                value={quantity}
                variant="outlined"
              />
              <Button
                style={{ flexShrink: 0, width: 120, marginLeft: 32, marginRight: 48 }}
                disabled={!productInput.productId || quantity <= 0  || quantity > 20}
                variant="contained"
                color="primary"
                onClick={insertProducts}
              >
                Add
              </Button>
            </Box>
          </Grid>
        </Grid>
        <Box 
          sx={{
            overflow: 'auto',
            height: 318,
            marginTop: '2%'
          }}
        >
          <DataGrid
            rows={soProducts}
            columns={columns}
            components={{
              Footer: CustomFooter
            }}
            componentsProps={{
              footer: { selectionModel, setOpenMeasureModal, deleteTableRows }
            }}
            onEditCellChangeCommitted={handleEditCellChangeCommitted}
            onSelectionModelChange={(newSelectionModel) => {
              setSelectionModel(newSelectionModel.selectionModel);
            }}
            selectionModel={selectionModel}
            checkboxSelection
            disableSelectionOnClick
            localeText={{
              noRowsLabel: 'No Products'
            }}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <h3>Total : {soProducts.reduce((prev, curr) => prev + curr.sellPrice , 0)} AED</h3>
        </Box>
      </Box>
      { openMeasureModal ?
      <MeasurementsModal
        open={openMeasureModal}
        edit={true}
        addProductMeasurements={addProductMeasurements}
        closeModal={handleMeasureModalClose}
      /> : null }
    </React.Fragment>
  )
};

export default connect (null, {setNewSOProducts}) (AddProducts);